@if (basicWidget) {
    <mvs-widget [widgetData]="basicWidget"></mvs-widget>
}
